import { render, staticRenderFns } from "./AiReasonBnr.vue?vue&type=template&id=2a753d96&scoped=true"
import script from "./AiReasonBnr.vue?vue&type=script&lang=js"
export * from "./AiReasonBnr.vue?vue&type=script&lang=js"
import style0 from "./AiReasonBnr.vue?vue&type=style&index=0&id=2a753d96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a753d96",
  null
  
)

export default component.exports